import styled, { css } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const FormWrapper = styled.div`
  padding: 10px 20px;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 16px;
`;

export const FormFieldWrapper = styled.div`
  grid-column-end: span ${({ span }) => span || 1};
`;

export const ActivityFormFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  grid-column-end: span 2;
`;

export const FormLabel = styled(typography.TitleTwoTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const FormTextInput = styled.input`
  width: ${({ width }) => width || 100}%;
  height: 40px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey003};
  border-radius: 4px;
  box-sizing: border-box;
  ${({ extendStyle }) => extendStyle || ''};
  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey003};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey003};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey003};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey003};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey005};
    outline: none;
  }
`;

export const FormValidationError = styled(typography.TitleTwoTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redDark};
`;

export const extendInputFieldStyle = css`
  width: calc(50% - 5px);
  margin-inline-end: 5px;
`;

export const AddOrEditVendorComponentLocationInputsWrapper = styled.div`
  display: flex;
`;

export const AddOrEditVendorComponenSingleLocationWrapper = styled.div`
  margin: 0 5px;
`;
